export type flashMessageConfig = {
    gradientColors?: string[],
    icon?: string,
    title?: string,
    message?: string,
    linkText?: string,
    linkURL?: string,
    textColor?: string,
    createdAt?: number,
}

type flashMessagesConfigType = {
    email_validation_email_change_success: flashMessageConfig
    email_validation_legacy_success: flashMessageConfig
    registration_confirm_success: flashMessageConfig
    registration_confirm_already_confirmed: flashMessageConfig
    registration_confirm_failure_invalid_token: flashMessageConfig
    registration_confirm_failure_already_logged_in: flashMessageConfig
    registration_confirm_failure_unknown_error: flashMessageConfig
    registration_send_email_error: flashMessageConfig
}

export type flashMessageNamesType = 'email_validation_email_change_success' | 'email_validation_legacy_success' | 'registration_confirm_success' | 'registration_confirm_already_confirmed' | 'registration_confirm_failure_invalid_token' | 'registration_confirm_failure_already_logged_in' | 'registration_confirm_failure_unknown_error' | 'registration_send_email_error'

export const FLASH_MESSAGES: flashMessagesConfigType = {
    email_validation_legacy_success: {
        gradientColors: ['#6157ff', '#00ccff'],
        icon: '😎',
        title: 'Success!',
        message: 'Your GIPHY account is now validated.',
        linkText: 'Home',
        linkURL: '/',
        textColor: '#ffffff',
    },
    email_validation_email_change_success: {
        gradientColors: ['#6157ff', '#00ccff'],
        icon: '😎',
        title: 'Success!',
        message: 'Your GIPHY email has been updated.',
        linkText: 'Home',
        linkURL: '/',
        textColor: '#ffffff',
    },
    registration_confirm_success: {
        gradientColors: ['#6157ff', '#00ccff'],
        icon: '😎',
        title: 'Success!',
        message: 'Your email is now validated.',
        linkText: 'Login Now',
        linkURL: '/login',
        textColor: '#ffffff',
    },
    registration_confirm_already_confirmed: {
        gradientColors: ['#6157ff', '#00ccff'],
        icon: '✌️',
        title: 'Confirmed!',
        message: 'Looks like your account was already validated!',
        linkText: 'Login Now',
        linkURL: '/login',
        textColor: '#ffffff',
    },
    registration_confirm_failure_invalid_token: {
        gradientColors: ['#e646b6', '#ff6666'],
        icon: '☠️',
        title: 'Busted!',
        message: 'Your confirmation link is expired or invalid.',
        linkText: '',
        linkURL: '',
        textColor: '#ffffff',
    },
    registration_confirm_failure_already_logged_in: {
        gradientColors: ['#e646b6', '#ff6666'],
        icon: '🧐',
        title: 'You are already signed in!',
        message: 'Sign out first, then try again.',
        linkText: 'Sign Out',
        linkURL: '/logout',
        textColor: '#ffffff',
    },
    registration_confirm_failure_unknown_error: {
        gradientColors: ['#e646b6', '#ff6666'],
        icon: '😭',
        title: 'Oops!',
        message: 'An unknown error occurred. Please try again.',
        linkText: '',
        linkURL: '',
        textColor: '#ffffff',
    },
    registration_send_email_error: {
        gradientColors: ['#e646b6', '#ff6666'],
        icon: '🤬',
        title: 'Error!',
        message: "There was a problem sending your confirmation email. Please contact GIPHY Support.",
        linkText: 'Contact Support',
        linkURL: 'https://support.giphy.com',
        textColor: '#ffffff',
    },
}

export const FLASH_MESSAGE_TEMPLATES = {
    success: {
        gradientColors: ['#6157ff', '#00ccff'],
        icon: '😎',
        title: 'Success!',
        message: 'It worked great!',
        linkText: 'Home',
        linkURL: '/',
        textColor: '#ffffff',
    },
    failure: {
        gradientColors: ['#e646b6', '#ff6666'],
        icon: '🤬',
        title: 'Failure!',
        message: "It didn't work!",
        linkText: 'Home',
        linkURL: '/',
        textColor: '#ffffff',
    },
}
